/////////////////////////////
// types for context of componets
/////////////////////////////

export const componentCode = () =>
    `
<template>
<div>

</div>
</template>

<script setup lang="ts">
</script>

<style scoped>
/* Add your component styles here */
</style>
`;